/**
 * Faixa fixa exibida enquanto a sessão for de impersonação.
 *
 * Não é enfeite: sem ela, um superadmin pode agir como cliente e esquecer que
 * está agindo como cliente. A faixa fica no topo, ocupa espaço de verdade e traz
 * o caminho de volta.
 */

import { useState } from "react";

import { useAuth } from "../auth/AuthContext";

export default function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useAuth();
  const [voltando, setVoltando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  if (!isImpersonating || !user) return null;

  async function voltar() {
    setVoltando(true);
    setErro(null);
    try {
      await stopImpersonation();
    } catch {
      setErro("Não foi possível voltar. Saia e entre novamente.");
    } finally {
      setVoltando(false);
    }
  }

  return (
    <div className="imp-banner" role="status">
      <span>
        Você está visualizando como <b>{user.full_name}</b>
        {user.tenant ? ` · ${user.tenant.name}` : ""}. Toda ação fica registrada em auditoria.
      </span>
      <div className="imp-acoes">
        {erro && <span className="imp-erro">{erro}</span>}
        <button type="button" className="btn btn-fantasma" onClick={voltar} disabled={voltando}>
          {voltando ? "Voltando…" : "Voltar para minha conta"}
        </button>
      </div>
    </div>
  );
}
